import { useState, useEffect } from 'react';

import { useGlobalDialog } from "../../Store/DialogManager";
import styled from 'styled-components';

import RequiredParametersHelper from '../../Utilities/Helpers/RequiredParametersHelper';
import { DbCloneIcon } from '../../Utilities/Helpers/IconHelper';

import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { CachingEnum } from '../../Utilities/Enums/CachingEnum';
import { DBInstanceCloneField, DBInstancesListField, InstanceAutoBackupsField } from '../../Utilities/Enums/ParametersEnum';

import CustomButton from '../../CustomViews/Elements/CustomButton';
import AutoCompleteDropdown from '../../CustomViews/Elements/AutoCompleteDropdown';
import FormTextField from '../../CustomViews/Elements/FormTextField';

import { DBCloneModalInterface, DBInstanceClone } from '../../Models/InstanceManagement/InstanceManagement';

const ModalContentContainer = styled.div <{ $darkMode?: boolean; }>`
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    // width: 20vw;
`;

export default function DBCloneModal(props: DBCloneModalInterface) {
    const { setDialogContent, setOpenGlobalDialog } = useGlobalDialog();
    let requiredFields = RequiredParametersHelper.dbClone();
    let { instanceName, openDBCloneModal, setopenDBCloneModal, handleCloneDB, DropdownData, dropdownFetchStatus } = props;

    //Use States
    let [errorMessages, setErrorMessages]: any = useState({});
    let [cloneForm, setcloneForm] = useState<DBInstanceClone>(new DBInstanceClone());

    const instanceNameProps = {
        name: DBInstanceCloneField.INSTANCE_NAME,
        title: 'Instance Name',
        fieldValue: cloneForm?.[DBInstanceCloneField.INSTANCE_NAME] ?? "",
        type: 'text',
        // required: requiredFields?.find((field: any) => field.keyName == DBInstanceCloneField.INSTANCE_NAME)?.keyName != null,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {
            setcloneForm((prev: any) => ({ ...prev, [DBInstanceCloneField.INSTANCE_NAME]: selectedValue }));
        },
    },
        sourceProps = {
            name: DBInstancesListField.SOURCE_NAME,
            title: 'Source',
            fieldValue: (instanceName ?? "") + " (Primary)",
            type: 'text',
            // required: requiredFields?.find((field: any) => field.keyName == DBInstancesListField.SOURCE_NAME)?.keyName != null,
            errorMessages: errorMessages,
            disabled: true,
            handleOnChange: (selectedValue: any) => {
                
            },
        },
        dataModeProps = {
            name: DBInstanceCloneField.DATA_MODE,
            title: 'Data Mode',
            fieldValue: cloneForm?.[DBInstanceCloneField.DATA_MODE] ?? 0,
            options: DropdownData?.[CachingEnum.DATA_MODE_LIST] ?? [],
            isLoadingDropdown: dropdownFetchStatus ?? false,
            // required: requiredFields?.find((field: any) => field.keyName == DBInstanceCloneField.DATA_MODE)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                setcloneForm(prev => ({ ...prev, [DBInstanceCloneField.DATA_MODE]: selectedValue?.id ?? 0 }));
            },
        },
        autoDeleteAfterDaysProps = {
            name: DBInstanceCloneField.AUTO_DELETE_AFTER_DAYS,
            title: 'Auto-delete After',
            fieldValue: cloneForm?.[DBInstanceCloneField.AUTO_DELETE_AFTER_DAYS] ?? 0,
            options: DropdownData?.[CachingEnum.AUTO_DELETE_AFTER_LIST] ?? [],
            isLoadingDropdown: dropdownFetchStatus ?? false,
            // required: requiredFields?.find((field: any) => field.keyName == DBInstanceCloneField.AUTO_DELETE_AFTER_DAYS)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                setcloneForm(prev => ({ ...prev, [DBInstanceCloneField.AUTO_DELETE_AFTER_DAYS]: selectedValue?.id ?? 0 }));
            },
        };

    //Event Handlers
    const onCloseDialog = async (e: any = null) => {
        if(e) {
            e.preventDefault();
        }

        if(setopenDBCloneModal) {
            setopenDBCloneModal(false);
        }

        setOpenGlobalDialog(false);
    }

    useEffect(() => {
        if(openDBCloneModal) {
            setDialogContent({
                title: "Clone Database for Debug",
                subtitle: <span>
                    Creates an isolated copy of <b>{instanceName}</b> on a separate debug instance. 
                    Clones are auto-deleted after the retention window and never affect production.
                    This will clone to default UAT database
                    </span>,
                clearDialog: onCloseDialog,
                onCloseDialog: onCloseDialog,
                actionButtons: renderActionButtons(),
                children: renderDialogContent(),
                dialogClassName: 'dbCloneModal',
            });
        }
    }, [openDBCloneModal, cloneForm, errorMessages]);

    //Rendering Functions
    const renderActionButtons = () => {
        return <>
            <CustomButton
                btnType={ButtonType.CANCEL}
                title='Cancel'
                onClick={(e: any) => {
                    onCloseDialog(e);
                }} />

            <CustomButton
                btnType={ButtonType.PRIMARY}
                startIcon={<DbCloneIcon />}
                title='Start Clone'
                onClick={(e: any) => {
                    if(handleCloneDB) {
                        handleCloneDB(cloneForm);
                    }
                }} />
        </>
    }

    const renderDialogContent = () => {
        return <ModalContentContainer>
            {/* <FormTextField {...instanceNameProps} /> */}
            <FormTextField {...sourceProps} />
            <AutoCompleteDropdown {...dataModeProps} />
            <AutoCompleteDropdown {...autoDeleteAfterDaysProps} />
        </ModalContentContainer>
    }

    return <></>
}
